import { campaignTypeEnum, campaignZoneEnum } from 'modules/common/enums';

export const campaignTargetDropdownItems = [
  {
    key: 'headCategoryKey',
    name: 'Head Category Key',
    mappedName: 'HeadCategoryKey',
  },
  {
    key: 'subCategoryKey',
    name: 'Sub Category Key',
    mappedName: 'SubCategoryKey',
  },
  {
    key: 'searchKeyword',
    name: 'Search Keyword',
    mappedName: 'SearchKeyword',
  },
];

export const campaignTypeToZoneMap = {
  [campaignTypeEnum.bannerImage]: [
    campaignZoneEnum.pharmacyCategory,
    campaignZoneEnum.pharmacyHomeScreen,
  ],
  [campaignTypeEnum.search]: [
    campaignZoneEnum.pharmacySubCateogry,
    campaignZoneEnum.pharmacySearch,
  ],
};

export const campaignTypeToTargetMap = {
  [campaignTypeEnum.bannerImage]: ['headCategoryKey'],
  [campaignTypeEnum.search]: ['subCategoryKey', 'searchKeyword'],
};
